module.exports = __webpack_public_path__ + "static/media/clickup.7cacd112.png";